<template>
    <div class="appt-cal-loading">
        <div class="topbar">
            <div class="left skeleton" />
            <div />
            <div class="right skeleton" />
        </div>
        <div class="cal-wrapper">
            <div class="left">
                <div class="skeleton" style="animation-delay: 0ms;" />
                <div class="skeleton" style="animation-delay: 100ms;" />
                <div class="skeleton" style="animation-delay: 200ms;" />
            </div>
            <div class="right">
                <div class="skeleton" style="animation-delay: 0ms;" />
                <div class="skeleton" style="animation-delay: 100ms;" />
                <div class="skeleton" style="animation-delay: 200ms;" />
                <div class="skeleton" style="animation-delay: 300ms;" />
                <div class="skeleton" style="animation-delay: 400ms;" />
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.appt-cal-loading {
    height: 300px;

    .skeleton {
        background-color: #f6f6f6;
        animation-duration: 8s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: loading;
        animation-timing-function: linear;
        background: #dedede;
        background: linear-gradient(to right, #dedede, #ebebeb, #d4d4d4);
        border-radius: 3px;
    }

    .topbar {
        display: flex;
        div {
            flex: 3;
            height: 3em;
            margin: 10px 0;
        }
        .left {
            flex: 1;
        }
        .right {
            flex: 1;
        }

        @media (max-width: 480px) {
            div {
                flex: 1;
            }
            .right {
                display: none;
            }
        }
    }

    .cal-wrapper {
        display: grid;
        grid-template-columns: 300px 1fr;
        column-gap: 15px;

        div {
            height: 2em;
            margin-bottom: 5px;
        }
    }

    @media (max-width: 480px) {
        .cal-wrapper {
            grid-template-columns: 1fr;
        }
    }
}
</style>
